import { ButtonGroup } from "react-bootstrap";
import { ArrowLeftIcon, ArrowRightIcon } from "../icons.jsx";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { Button } from "../Button.tsx";

export const FullCalendarWeekSwitcher = ({ calendarRef, onTodayClick }) => {
  const calendarApi = calendarRef.getApi();
  const todayDate = DateTime.now();
  const calendarDate = DateTime.fromJSDate(calendarApi.getDate());
  const { t } = useTranslation();

  const isCurrentWeek = todayDate.weekNumber === calendarDate.weekNumber && todayDate.year === calendarDate.year;

  return (
    <div className="mb-3">
      <ButtonGroup aria-label="Calendar navigation" className="calendar-today-btn bg-white">
        <Button
          testId="prev-week"
          variant="outline-secondary"
          className="px-3 border-right-0"
          onClick={() => calendarApi.incrementDate({ weeks: -1 })}
        >
          <ArrowLeftIcon />
        </Button>
        <Button
          testId="today"
          variant="outline-secondary"
          active={isCurrentWeek}
          className="px-3 fw-bold border-left-0 border-right-0"
          onClick={() => onTodayClick()}
        >
          {t("Today", "Tänään")}
        </Button>
        <Button
          testId="next-week"
          variant="outline-secondary"
          className="px-3 border-left-0"
          onClick={() => calendarApi.incrementDate({ weeks: 1 })}
        >
          <ArrowRightIcon />
        </Button>
      </ButtonGroup>
    </div>
  );
};

